const getters = {
  menus: state => state.menu.menus,
  menusOpened: state => state.menu.opened,
  menusCreated: state => state.menu.created,
  userInit: state => state.user.inited,
  userName: state => state.user.user.username,
  permissions: state => state.permission.permissions,
  permissionsInited: state => state.permission.permissionsInited
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js